import React from 'react';
import PropTypes from 'prop-types';
import Paginator from './results/paginator';
import OffMarketResultCard from './results/off_market_result_card';

import { connect } from 'react-redux';
import { EmptyState } from './results/empty_state';
import EmptyStateBadges from './results/empty_state_badges';

function OffMarketResultsCardList(
  {
    allResults,
    containerRef,
    loading,
    selectAll,
    selectedPropertyIds,
    onSelectToggle
  }) {
  return (
    <div className="h-100 overflow-auto position-relative z-2">
      {allResults.length > 0 && (
        <>
          <div className={`mt-1 p-3 transition-opacity ${loading ? 'opacity-75' : 'opacity-100'}`}>
            {allResults.map(result => (
              <OffMarketResultCard
                isSelected={selectAll || selectedPropertyIds.has(result.propertyId)}
                key={result.propertyId}
                result={result}
                onSelectToggle={onSelectToggle}
              />
            ))}
          </div>

          <div className="d-flex justify-content-center mb-4">
            <Paginator containerRef={containerRef} />
          </div>
        </>
      )}
      {allResults.length === 0 && (
        <div>
          <EmptyState subtitle="Expand your search to find matching, off market properties" title="No matches" />
          <EmptyStateBadges />
        </div>
      )}
    </div>
  );
}

OffMarketResultsCardList.propTypes = {
  allResults: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired
  })),
  containerRef: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  selectAll: PropTypes.bool.isRequired,
  selectedPropertyIds: PropTypes.object.isRequired,
  onSelectToggle: PropTypes.func.isRequired
};

const mapStateToProps = ({
  results: {
    offMarketResults
  },
  ui: { loading }
}) => {
  return {
    allResults: offMarketResults,
    loading
  };
};
export default connect(mapStateToProps)(OffMarketResultsCardList);

